// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const downstreamOperationId = (z.number());
export const downstreamOperation = z.object({
    id: downstreamOperationId,
    name: z.string().nullable(),
    settings: z.unknown().nullable(),
    abbreviation: z.string().nullable(),
});
export const downstreamOperationInitializer = z.object({
    id: downstreamOperationId.optional(),
    name: z.string().optional().nullable(),
    settings: z.unknown().optional().nullable(),
    abbreviation: z.string().optional().nullable(),
});
export const downstreamOperationMutator = z.object({
    id: downstreamOperationId.optional(),
    name: z.string().optional().nullable(),
    settings: z.unknown().optional().nullable(),
    abbreviation: z.string().optional().nullable(),
});
//# sourceMappingURL=DownstreamOperation.js.map